import { render, staticRenderFns } from "./demandFileManagement.vue?vue&type=template&id=df6cd2e4"
import script from "./demandFileManagement.vue?vue&type=script&lang=js"
export * from "./demandFileManagement.vue?vue&type=script&lang=js"
import style0 from "./demandFileManagement.vue?vue&type=style&index=0&id=df6cd2e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports